<template>
  <div class="volume-wrapper">
    <img class="volume-icon" :src="require(sliderValue > 0 ? '@/assets/images/voice@2x.png' : '@/assets/images/voice_mute.png')" alt="volume" @click="toggleMute"/>
    <a-slider
      class="volume-sider"
      :tooltipVisible="false"
      v-model:value="sliderValue"
      @change="changeVolume"
    />
  </div>
</template>

<script lang="ts">
import { ref } from "vue";
import { GsSdkServiceKey } from "@/services/gs-sdk.service";
import useRequiredInject from "@/composable/useRequiredInject";
import { getItem, setItem } from '@/core/utils/storage';

export default {
  name: "Volume",
  setup() {
    const gsSdkService = useRequiredInject(GsSdkServiceKey);
    const key = 'volume'
    const value = getItem('local', key)
    const DEF_VOLUME = 50
    const defaultValue = +( value !== null ? value : DEF_VOLUME)
    const sliderValue = ref<number>(defaultValue);
    // 更改音量
    const changeVolume = (value: number, flag = false) => {
      const validVal = Number((value / 100).toFixed(2));
      gsSdkService?.submitVolume(validVal);
      if(!flag){
        setItem('local', key, value)
      }
      gsSdkService.submitMute(validVal <= 0)
    };
    gsSdkService?.on("onDataReady", function (event) {
      changeVolume(defaultValue);
    });

    function toggleMute(){
      if(sliderValue.value > 0){
        changeVolume(0, true)
        sliderValue.value = 0
      }else{
        let value = +getItem('local', key)
        if(value <= 0) value = DEF_VOLUME
        changeVolume(value, true)
        sliderValue.value = value
      }
    }
    return {
      sliderValue,
      changeVolume,
      toggleMute
    };
  },
};
</script>

<style scoped lang="less">
.volume-wrapper {
  display: flex;
  align-items: center;
  height: 100%;

  .volume-icon {
    display: block;
    width: 18px;
    height: 18px;
    margin-right: 10px;
    cursor: pointer;
  }

  .volume-sider {
    width: 100px;
    margin: 0;
    @height: 2px;

    :deep {
      .ant-slider-rail {
        height: @height;
        border-radius: 0;
      }
      .ant-slider-track {
        height: @height;
        border-radius: 0;
      }
      .ant-slider-step {
        height: @height;
      }
      .ant-slider-handle {
        margin-top: -3px;
        width: 8px;
        height: 8px;
        background: #ffffff;
        border-radius: 50%;
        border: none;
      }
    }
  }
}
</style>
